import { AIChatBoxMessagesInterceptor, linkButton, systemMessage, temporaryText } from '@aston/ai-chat';
import { TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectConfig } from '../../root-store/app-store/selectors';
import { AppConfiguration } from '../../app.configuration';
import * as R from '../../routes-definitions';


@Injectable({ providedIn: 'any' })
export class FederationAIChatBoxMessagesInterceptor extends AIChatBoxMessagesInterceptor {
	i18n = inject(TranslateService)
	fatStore = inject(Store)

	config = toSignal(this.fatStore.select(selectConfig), { initialValue: {} as AppConfiguration })

	generateTemporaryButtons(_text: string) {
		const buttons = []

		if (this.isFlakyResponse()) {
			const frb = this.buttonsFromFlakyResponse()

			if (frb.length) frb.forEach(b => buttons.push(b))
			else if (this.flakyResponsesCount() % 5 === 0) {
				const contactUs = this.i18n.instant('Support.Contact')
				const byZoho = this.i18n.instant('Support.TicketUrlText')
				buttons.push(linkButton(`${contactUs} ${byZoho}`, this.config().helpUrl))
			}
		}

		return systemMessage({ html: temporaryText(buttons.join('')) })
	}

	replaceWellKnownTokens(text: string) {
		this.trackFlakyResponse(text)

		return this.replaceTextAndEntityTokens(text, value => value
			.replace(/【[^】]*】/g, '') // remove files references
			.replace(/08\s*90\s*21\s*38\s*39/g, `[08 90 21 38 39](tel:${this.i18n.instant('Support.Phone')})`)
			.replace(/\+33\s*8\s*90\s*21\s*38\s*39/g, `[08 90 21 38 39](tel:${this.i18n.instant('Support.Phone')})`)
			.replace(/support@astonai.com/g, `[${this.i18n.instant('Support.Email')}](mailto:${this.i18n.instant('Support.Email')})`)
			.replace(/ DSO /i, ` [DSO](${R.getOverviewFullPath(R.DashboardsPageFinancialRoutePath)}) `)
			.replace(/ scoring/i, ` [scoring](${R.getOverviewFullPath(R.DashboardsPageOperationalRoutePath)})`)
			.replace(/ retard/i, ` [retard](${R.getOverviewFullPath(R.DashboardsPageFinancialRoutePath)})`))
	}
}
